import { preview } from '@/components/form/preview'
import { Stack, Typography } from '@mui/material'
import { CheckCircleOutline } from '@workwave-tidal/core/icons'

import { CompanyEmail } from './CompanyEmail'
import { CompanyPhone } from './CompanyPhone'
import { Pods } from './Pods'
import { FieldPointsContainer } from './FieldPointsContainer'

import { useTexts } from '../../hooks/useTexts'

import type { TrackingAppViewProps as Props } from '../../types'

export function Content(props: Props) {
  const { formValues } = props

  const texts = useTexts()

  return (
    <>
      <preview.SectionTitle variant="alternative">{texts.companyInformation}</preview.SectionTitle>

      <preview.Field testId="trackingPage-companyName" label={texts.companyName}>
        <preview.Value variant="alternative">
          {formValues.companyName || <preview.NullValue />}
        </preview.Value>
        {formValues.overrideTrackingSenderName && (
          <FieldPointsContainer>
            <Stack direction="row" alignItems="center" spacing={0.5}>
              <CheckCircleOutline sx={{ fontSize: '16px', flexShrink: 0 }} color="primary" />
              <Typography variant="caption" lineHeight={1}>
                {texts.overrideTrackingSenderNameHelper}
              </Typography>
            </Stack>
          </FieldPointsContainer>
        )}
      </preview.Field>

      <preview.Field testId="trackingPage-companySlogan" label={texts.companySlogan}>
        {formValues.companySlogan || '-'}
      </preview.Field>

      <CompanyPhone
        companyPhone={formValues.companyPhone || '-'}
        showContactPhone={formValues.showContactPhone && !!formValues.companyPhone}
      />

      <CompanyEmail
        companyEmail={formValues.companyEmail || '-'}
        showContactEmail={formValues.showContactEmail && !!formValues.companyEmail}
        useCompanyEmailAsReplyTo={formValues.useCompanyEmailAsReplyTo && !!formValues.companyEmail}
      />

      <preview.Divider />

      <preview.Field testId="trackingPage-showEtaRange" label={texts.showEtaRange}>
        {texts.onOff(formValues.showEtaRange)}
      </preview.Field>

      <preview.Divider />

      <Pods
        showAudioPod={formValues.showAudioPod}
        showPicturePod={formValues.showPicturePod}
        showNotePod={formValues.showNotePod}
        showSignaturePod={formValues.showSignaturePod}
      />
    </>
  )
}
